import Icon from '../components/Icon.vue'

Icon.register({"boxes":{"width":576,"height":512,"paths":[{"d":"M560 288H480V384L448 362.7 416 384V288H336C327.2 288 320 295.2 320 304V496C320 504.8 327.2 512 336 512H560C568.8 512 576 504.8 576 496V304C576 295.2 568.8 288 560 288zM176 224H400C408.8 224 416 216.8 416 208V16C416 7.2 408.8 0 400 0H320V96L288 74.7 256 96V0H176C167.2 0 160 7.2 160 16V208C160 216.8 167.2 224 176 224zM240 288H160V384L128 362.7 96 384V288H16C7.2 288 0 295.2 0 304V496C0 504.8 7.2 512 16 512H240C248.8 512 256 504.8 256 496V304C256 295.2 248.8 288 240 288z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/boxes.js
// module id = null
// module chunks = 